import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    '& .MuiTableCell-root': {
      fontSize: theme.typography.body1.fontSize,
    },
  },
  pending: {
    backgroundColor: theme.palette.statuses.pending,
    color: theme.palette.common.white,
  },
  awaiting_review: {
    backgroundColor: theme.palette.statuses.inactive,
    color: theme.palette.common.white,
  },
  approved: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  disapproved: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  risk_assumed: {
    backgroundColor: theme.palette.grapePurple,
    color: theme.palette.common.white,
  },
  inactive: {
    backgroundColor: theme.palette.dashboard.chart.primary.inactive,
    color: theme.palette.common.white,
  },
}))

export default useStyles
